import { RADIUS } from './mercator';

export const EQUATOR = 2 * Math.PI * RADIUS;
export const SUBEQUATOR = 1 / EQUATOR;
export const HALF_EQUATOR = EQUATOR / 2;
export { RADIUS };
